import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/diagnostic/21.jpg'
import _imports_1 from '@/assets/images/diagnostic/22.jpg'
import _imports_2 from '@/assets/images/diagnostic/23.jpg'
import _imports_3 from '@/assets/images/diagnostic/24.jpg'
import _imports_4 from '@/assets/images/diagnostic/25.jpg'
import _imports_5 from '@/assets/images/diagnostic/26.jpg'
import _imports_6 from '@/assets/images/diagnostic/27.jpg'
import _imports_7 from '@/assets/images/diagnostic/28.jpg'
import _imports_8 from '@/assets/images/diagnostic/29.jpg'
import _imports_9 from '@/assets/images/diagnostic/211.jpg'
import _imports_10 from '@/assets/images/diagnostic/212.jpg'
import _imports_11 from '@/assets/images/diagnostic/221.jpg'


const _withScopeId = n => (_pushScopeId("data-v-76eaacaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "diagnostic" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("section", { class: "diagnostic__services" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "heading" }, "Услуги диагностики"),
    /*#__PURE__*/_createElementVNode("ul", { class: "diagnostic__list" }, [
      /*#__PURE__*/_createElementVNode("li", {
        class: "diag__item",
        id: "car-milage-diagnostic"
      }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "diag__title" }, "1.Диагностика реального пробега от 2000₽"),
        /*#__PURE__*/_createElementVNode("div", { class: "diag__info" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_0,
            alt: "car milage diagnostic"
          }),
          /*#__PURE__*/_createElementVNode("p", null, "В современном мире нельзя доверять всему, что ты видишь. Пробег, указанный на приборной панели, с большой долей вероятности может превышать фактический. Наши специалисты выявят реальный пробег вашего автомобиля по прямым или косвенными признакам.")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "diag__item",
        id: "before-buy-diagnostic"
      }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "diag__title" }, "2.Диагностика перед покупкой от 5000₽"),
        /*#__PURE__*/_createElementVNode("div", { class: "diag__info" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_1,
            alt: "before buy diagnostic"
          }),
          /*#__PURE__*/_createElementVNode("p", null, "В диагностику перед покупкой входит комплекс услуг. Мы проверим всю электрику, сделаем диагностику ЭБУ, проверим подвеску и двигатель. Выдадим протокол с полным списком неисправностей и рекомендациями.")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "diag__item",
        id: "complex-diagnostic"
      }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "diag__title" }, "3.Системная комплексная диагностика от 5000₽"),
        /*#__PURE__*/_createElementVNode("div", { class: "diag__info" }, [
          /*#__PURE__*/_createElementVNode("img", {
            style: {"object-fit":"contain"},
            src: _imports_2,
            alt: "complex diagnostick"
          }),
          /*#__PURE__*/_createElementVNode("p", null, "В системную комплексную диагностику входит целый список работ, необходимых для устранения нестандартной проблемы. Будь то использование топливных манометров, прочистка форсунок или прозвонка всех кос проводки.")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "diag__item",
        id: "install-starline"
      }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "diag__title" }, "4.Установка сигнализации Starline"),
        /*#__PURE__*/_createElementVNode("div", { class: "diag__info" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_3,
            alt: "starline guard system"
          }),
          /*#__PURE__*/_createElementVNode("p", null, "Наш сервис является авторизованным пунктом по установке сигнализаций данного бренда. Так же мы устанавливаем любое дополнительное электрооборудование.")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "diag__item",
        id: "correcting-mileage"
      }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "diag__title" }, "5.Корректировка пробега от 2000₽"),
        /*#__PURE__*/_createElementVNode("div", { class: "diag__info" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_4,
            alt: "correct milage"
          }),
          /*#__PURE__*/_createElementVNode("p", null, "Если вы поставили себе контрактный двигатель или произвели капитальный ремонт, и при этом хотите держать под контролем его пробег, наши специалисты сбросят или откорректируют ваш одометр.")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "diag__item",
        id: "ecu-diagnostic"
      }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "diag__title" }, "6.Диагностика ЭБУ на столе от 2000₽"),
        /*#__PURE__*/_createElementVNode("div", { class: "diag__info" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_5,
            alt: "ecu diagnostic"
          }),
          /*#__PURE__*/_createElementVNode("p", null, " Не всегда есть возможность корректно произвести диагностику ЭБУ в условиях штатного установочного положения. Наши специалисту вынут ЭБУ из вашего автомобиля и произведут диагностику, используя самое новейшее оборудование. При необходимости схема будет осмотрена под микроскопом, пропаяна и восстановлена. ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "diag__item",
        id: "srs-recovery"
      }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "diag__title" }, "7.Восстановление блоков SRS от 3000₽"),
        /*#__PURE__*/_createElementVNode("div", { class: "diag__info" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_6,
            alt: "srs repair"
          }),
          /*#__PURE__*/_createElementVNode("p", null, " После срабатывания подушек безопасности в блок SRS AIRBAG записывается информация о столкновении и происходит блокировка системы управления. Для снятия блокировки необходимо выполнить ремонт и перепрошивку блока. ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "diag__item",
        id: "verify-keys"
      }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "diag__title" }, "8.Идентификация наличия прописанных ключей от 2000₽"),
        /*#__PURE__*/_createElementVNode("div", { class: "diag__info" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_7,
            alt: "progromatic keys"
          }),
          /*#__PURE__*/_createElementVNode("p", null, " Важная часть после покупки. Для собственной безопасности владельцу стоит понимать, сколько ключей прописано в его машине и сколько ключей он получил на руки. При желании можно стереть и записать только новые. ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "diag__item",
        id: "cleaning-nozzles"
      }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "diag__title" }, "9.Промывка форсунок от 2000₽"),
        /*#__PURE__*/_createElementVNode("div", { class: "diag__info" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_8,
            alt: "cleaning nozzles"
          }),
          /*#__PURE__*/_createElementVNode("ul", null, [
            /*#__PURE__*/_createElementVNode("li", null, "По каким признакам узнать о необходимости чистки форсунок?"),
            /*#__PURE__*/_createElementVNode("li", null, "1.Нарушен холостой ход (плавают обороты)"),
            /*#__PURE__*/_createElementVNode("li", null, "2.Ухудшилась динамика разгона(автомобиль не разгоняется, как раньше)"),
            /*#__PURE__*/_createElementVNode("li", null, "3.Увеличился расход топлива"),
            /*#__PURE__*/_createElementVNode("li", null, "4.Ошибки по датчикам катализатора (лямбда-зондам)"),
            /*#__PURE__*/_createElementVNode("li", null, "5.Пропуски в воспламенении - троит двигатель, не все цилиндры работают.")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "diag__item",
        id: "lada-diagnostic"
      }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "diag__title" }, "10.Диагностика ВАЗ от 2000₽"),
        /*#__PURE__*/_createElementVNode("div", { class: "diag__info" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_9,
            alt: "lada diagnostic"
          }),
          /*#__PURE__*/_createElementVNode("p", null, " Мы знаем все детcкие и взрослые болезни наших машин. Потому быстро и качественно найдем и устраним все проблемы. ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "diag__item",
        id: "variant-coding"
      }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "diag__title" }, "11.Вариантное кодирование."),
        /*#__PURE__*/_createElementVNode("div", { class: "diag__info" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_10,
            alt: "variant coding"
          }),
          /*#__PURE__*/_createElementVNode("p", null, " Если вы установили новую оптику или дополнительные опции на ваш автомобиль, возможно, что опция не будет работать без программирования. Мы работаем на оборудовании BOSСH, которое позволяет как прописывать так и удалять варианты комплектации автомобиля. ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "diag__item",
        id: "unlock-car-radio"
      }, [
        /*#__PURE__*/_createElementVNode("h4", { class: "diag__title" }, "12.Разблокировка штатных магнитол любой сложности от 3000₽"),
        /*#__PURE__*/_createElementVNode("div", { class: "diag__info" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_11,
            alt: "unlock audio system"
          })
        ])
      ])
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}